import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismIcon } from '@mylighthouse/prism-ember';
import type { Dayjs } from 'dayjs';
import type SmartInsightDay from 'lumen/models/smart-insights/smart-insight-day';
import { DRAWER_IDS } from 'lumen/utils/constants/general-constants';

import styles from './th-day-table-si-row.module.css';

interface HotelPricingAssistantTableCellsDayTableThDayTableSiRowSignature {
  Args: {
    date: Dayjs;
    isLastColumn?: boolean;
  };
}

export default class HotelPricingAssistantTableCellsDayTableThDayTableSiRow extends Component<HotelPricingAssistantTableCellsDayTableThDayTableSiRowSignature> {
  @service declare drawer: Services['drawer'];
  @service declare router: Services['router'];
  @service declare smartInsights: Services['smart-insights'];
  @service declare usageAnalytics: Services['usage-analytics'];

  get smartInsightCountForDay(): number | null {
    const dateStr = this.args.date.format('YYYY-MM-DD');
    const day = this.smartInsights.smartInsightDays.find(
      (d: SmartInsightDay) => d.stayDate === dateStr,
    );
    if (!day) {
      return null;
    }
    return day.insightEntriesSortedByRelevance.length;
  }

  @action
  openSmartInsightsForDay(): void {
    if (!this.smartInsightCountForDay) {
      return;
    }

    const dateStr = this.args.date.format('YYYY-MM-DD');
    void this.router.transitionTo({
      queryParams: { smartInsightsDay: dateStr },
    });
    this.drawer.expandDrawer(DRAWER_IDS.SMART_INSIGHTS_DRAWER);
    this.usageAnalytics.track('Smart Insight Rationale Opened', {
      eventTrigger: 'mrt-si-row',
      product: 'pricing-manager',
    });
  }

  <template>
    <button
      class="text-200--regular flex w-full items-center justify-end gap-100 border-0 pb-100 tabular-nums
        {{styles.si-row}}
        {{if @isLastColumn 'pr-400' 'pr-200'}}
        {{if this.smartInsightCountForDay styles.si-row-hover-zone}}"
      type="button"
      {{on "click" this.openSmartInsightsForDay}}
    >
      {{#if this.smartInsights.getSmartInsightsTask.isRunning}}
        <div class="loading-pulse h-2 w-[44px]"></div>
        <PrismIcon @color="disabled" @name="smart-insights" @size="small" />
      {{else}}
        {{if this.smartInsightCountForDay this.smartInsightCountForDay "-"}}
        <span class={{unless this.smartInsightCountForDay "invisible"}}>
          <PrismIcon
            @color="on-intelligence"
            @name="smart-insights"
            @size="small"
          />
        </span>
      {{/if}}
    </button>
  </template>
}
